module.exports = __webpack_public_path__ + "img/time.c7902822.svg";